<template>
  <div class="nav-container" :style="cssVars">
    <div class="nav-swap">
      <LogoTitle class="nav-logo" is-white @click="router('')" />
      <div class="menu-button" @click.stop="showMenu">
        <img src="../assets/menu.svg" alt="menu">
      </div>
      <div v-if="isShowMenu || windowWidth >= 1000" ref="menu" class="nav-main">
        <div :class="{active: path === '/'}"
             class="nav-item"
             @click="router('')">
          Home
        </div>
        <div :class="{active: path === '/privacy'}"
             class="nav-item"
        >
          <a class="nav-a" href="/privacy">
            Privacy
          </a>
        </div>
        <div :class="{active: path === '/terms'}"
             class="nav-item"
        >
          <a class="nav-a" href="/terms">
            Terms
          </a>
        </div>
        <div :class="{active: path === '/deleteAccount'}"
             class="nav-item"
             @click="router('deleteAccount')"
        >
          Delete Account
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LogoTitle from "@/components/LogoTitle";
import { useRoute } from 'vue-router'
import {computed} from "vue";

const route = useRoute()
const path = computed(() => route.path)
</script>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Navigation",
  data() {
    return {
      isShowMenu: false,
      windowWidth: window.innerWidth
    }
  },
  props: {
    isBackground: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    cssVars() {
      return {
        '--nav-background': this.isBackground ? 'linear-gradient(90deg, #1976D2 0%, #03A9F4 100%)' : '',
      };
    }
  },
  methods: {
    router(type) {
      let link = '/' + type
      this.$router.push(link)
      this.isShowMenu = false
    },
    showMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    handleClickOutside(event) {
      const menuEl = this.$refs.menu
      if (menuEl && !menuEl.contains(event.target) && this.isShowMenu) {
        this.isShowMenu = false
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.updateWindowWidth)
  }
}
</script>

<style lang="scss" scoped>
.nav-a {
  color: white;
  text-decoration: none;
}
.nav-container {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
  background: var(--nav-background);
  position: fixed;
  width: -webkit-fill-available;
}

.nav-swap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 12px;
  display: flex;
  align-items: center;

  .nav-logo {
    flex: auto;
    cursor: pointer;
  }

  .menu-button {
    display: none;
  }

  .nav-main {
    display: flex;
    color: white;
    gap: 36px;
    height: 24px;

    .active {
      border-bottom: 2px solid white;
    }

    .nav-item {
      cursor: pointer;
      transition-property: border-bottom;
      transition-duration: .25s;
    }

    .nav-item:hover {
      border-bottom: 2px solid white;
    }
  }
}

@media screen and (max-width: 1000px) {
  .nav-container {
    padding: .75rem;
    background: linear-gradient(90deg, #1976D2 0%, #03A9F4 100%);
  }

  .nav-swap {
    max-width: 100vw;
    padding: 0 1rem;

    .menu-button {
      display: flex;
      align-items: center;

      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    .nav-main {
      position: absolute;
      flex-direction: column;
      right: .4rem;
      top: 3rem;
      height: max-content;
      background-color: rgba(255, 255, 255, .9);
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
      border-radius: .6rem;
      gap: 0;

      .nav-item {
        color: black;
        height: 3rem;
        line-height: 3rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);
        padding: 0 1rem;
      }

      .nav-item:last-child {
        border-bottom: none;
      }

      .active {
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);
        color: red;
        font-weight: 600;
      }

      .nav-item:hover {
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      }
    }
  }
}


</style>